import { useState } from "react";
import blackDeleteIcon from "../assets/black-delete-icon.svg";
import saveIcon from "../assets/save-icon.svg";

const DIAGNOSIS_TYPE_OPTIONS = ["Primary", "Secondary"];

const gridColsClass = "grid grid-cols-[0.5fr_1fr_4fr_1fr_0.6fr] items-start";

const DiagnosisFormAi = () => {
  const [diagnoses, setDiagnoses] = useState([]);
  const [code, setCode] = useState("");
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");

  const handleAdd = () => {
    const trimmedCode = code.trim();
    const trimmedTitle = title.trim();

    if (!trimmedCode || !trimmedTitle || !type) return;

    setDiagnoses((prev) => [
      ...prev,
      {
        code: trimmedCode,
        title: trimmedTitle,
        type,
      },
    ]);
    setCode("");
    setTitle("");
    setType("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  const handleDelete = (index) => {
    setDiagnoses((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="flex items-center justify-between gap-3 pt-[30px]">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="relative w-full min-w-0 box-border overflow-hidden h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[32px] flex items-center">
            <input
              type="text"
              placeholder="Diagnosis Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full min-w-0 bg-transparent border-none outline-none focus:outline-none focus:ring-0 focus:border-none shadow-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] placeholder:text-[#8B8B8B]"
            />
          </div>

          <div className="relative w-full min-w-0 box-border overflow-hidden h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[32px] flex items-center">
            <input
              type="text"
              placeholder="Diagnosis Description"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full min-w-0 bg-transparent border-none outline-none focus:outline-none focus:ring-0 focus:border-none shadow-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] placeholder:text-[#8B8B8B]"
            />
          </div>

          <div className="relative w-full min-w-0 box-border h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="absolute inset-0 w-full h-full pl-[32px] pr-[48px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
            >
              <option value="" disabled hidden>
                Diagnosis Type
              </option>
              {DIAGNOSIS_TYPE_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                  d="M7 10.5L14 17.5L21 10.5"
                  stroke="#5AC69F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleAdd}
          className="shrink-0 w-[88px] h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
        >
          ADD
        </button>
      </div>
      <div className="pt-[30px]">
        <div className={gridColsClass}>
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Diagnosis
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Diagnosis Description
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Diagnosis Type
          </div>

          <div className="justify-self-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Action
          </div>
        </div>

        <div className="mt-[30px] flex flex-col gap-y-[21px]">
          {diagnoses.map((item, index) => (
            <div
              key={`${item.code}-${item.type}-${index}`}
              className={gridColsClass}
            >
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {index + 1}.
              </div>

              <div className="min-w-0 pr-[12px] break-all font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.code || "--"}
              </div>

              <div className="min-w-0 pr-[40px] font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.title || "--"}
              </div>

              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.type || "--"}
              </div>

              <button
                type="button"
                onClick={() => handleDelete(index)}
                className="flex items-center justify-self-center bg-transparent border-none cursor-pointer"
              >
                <img src={blackDeleteIcon} alt="delete icon" />
              </button>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end mt-[12px]">
        <button className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px]  2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal">
          SAVE
          <img src={saveIcon} alt="save" className="pl-[16px]" />
        </button>
      </div>
    </div>
  );
};

export default DiagnosisFormAi;
